<app-header-one [sticky]="true"></app-header-one>

<section class="about-page section-b-space">
  <div class="container">
    <div class="row">
      <div class="col-lg-12">
        <div class="banner-section">
          <ngb-carousel
            *ngIf="banners.length > 0"
            [showNavigationArrows]="false"
            [showNavigationIndicators]="true"
          >
            <ng-template ngbSlide *ngFor="let item of banners">
              <a [href]="item.linkDirecionamento" target="_blank">
                <img
                  [src]="item.linkImagemBanner"
                  class="img-fluid"
                  alt="Banner"
                />
              </a>
            </ng-template>
          </ngb-carousel>
        </div>
      </div>
    </div>
  </div>
  <div class="container">
    <div class="row partition2">
      <app-produtoshome> </app-produtoshome>
    </div>
  </div>
</section>

<section class="section p-t-0">
  <div class="container">
    <div class="row">
      <div class="col theme-tab">
        <ul
          ngbNav
          #nav="ngbNav"
          [(activeId)]="active"
          class="tabs tab-title justify-content-center nav nav-pills"
        >
          <li
            *ngFor="let collection of productCollections"
            [ngbNavItem]="collection"
          >
            <a ngbNavLink>
              {{ collection }}
            </a>
            <ng-template ngbNavContent>
              <div class="no-slider row">
                <ng-container
                  *ngFor="
                    let product of getCollectionProducts(collection)
                      | slice : 0 : 8
                  "
                >
                  <div class="product-box">
                    <app-product-box-one
                      [product]="product"
                      [currency]="productService?.Currency"
                    >
                    </app-product-box-one>
                  </div>
                </ng-container>
              </div>
            </ng-template>
          </li>
        </ul>
        <div [ngbNavOutlet]="nav" class="mt-2"></div>
      </div>
    </div>
  </div>
</section>
<!-- Tab product End -->

<!-- services start-->
<div class="container">
  <section class="service border-section small-section">
    <app-services></app-services>
  </section>
</div>
<!-- services End -->

<!-- blog section start-->
<section class="blog p-t-0">
  <div class="container">
    <div class="row">
      <div class="col">
        <div class="title1 section-t-space">
          <h4>Histórias Recentes</h4>
          <h2 class="title-inner1">BLOG</h2>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <app-blog [blogs]="blog"></app-blog>
      </div>
    </div>
  </div>
</section>
<!-- blog section End -->

<!--  logo section start-->
<section class="section-b-space">
  <div class="container">
    <div class="row">
      <div class="col-md-12">
        <app-logo [logos]="logo"></app-logo>
      </div>
    </div>
  </div>
</section>
<!--  logo section End-->

<app-newsletter></app-newsletter>
<app-footer-one></app-footer-one>
